if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('.js-product-media-modal__thumbnail');
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
          this.addEventListener('pointerup', (event) => {
            if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.show();
          });
        } else {
          this.addEventListener('click', (event) => {
            if (event.target === this) this.show();
          });
        }
        this.querySelectorAll('.product-media-modal__toggle').forEach(button => {
          button.addEventListener('click', this.hide.bind(this, false));
        })
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initThumbnails()
      }

      initThumbnails(){
        this.buttons.forEach(button => {

            button.addEventListener('click', (event) => {

              this.buttons.forEach((element) => {
                element.classList.remove('active');
              });

              const index = parseInt(event.target.dataset.thumbnailId);
              const targetThumbnail = this.querySelector(`[data-media-id="${index}"]`);

              if (targetThumbnail) {
                if ('scrollIntoView' in targetThumbnail && typeof targetThumbnail.scrollIntoView === 'function') {
                  targetThumbnail.scrollIntoView({ behavior: 'smooth', block: 'start' });
                } else {
                  targetThumbnail.scrollIntoView(true);
                }

                button.classList.add('active');
              }
            });
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy?.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy?.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia?.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
